import { useZipRootLoaderData } from "./useZipRootLoaderData";

export function useEnrollLink(pbp: string, hcode: string, year: string) {
  const { enrollmentLink, zip } = useZipRootLoaderData();
  const providerID = sessionStorage.getItem("doctorProviderID");
  console.log(enrollmentLink);

  const url = new URL(enrollmentLink);

  url.searchParams.set("pbp", pbp);
  url.searchParams.set("hcode", hcode);
  url.searchParams.set("coverageYear", year);
  url.searchParams.set("zipCode", zip);

  if (providerID) {
    url.searchParams.set("providerId", providerID);
  }
  url.searchParams.set(
    "HasMedicaidCoverage",
    sessionStorage.getItem("isCoverage") === "true" ? "Yes" : "No"
  );
  url.searchParams.set(
    "ReceiveVeterans",
    sessionStorage.getItem("isVeteran") === "true" ? "Yes" : "No"
  );
  url.searchParams.set(
    "HasDiabetes",
    sessionStorage.getItem("isDiabetes") === "true" ? "Yes" : "No"
  );
  url.searchParams.set(
    "HasHeartConditions",
    sessionStorage.getItem("isHeartConditions") === "true" ? "Yes" : "No"
  );
  url.searchParams.set(
    "HasESRD",
    sessionStorage.getItem("isESRD") === "true" ? "Yes" : "No"
  );

  return url.toString();
}
